import { useDelightsEnabled } from '@app/utils/delight/delights';
import { isSnowFallSeasonActive } from '@app/utils/delight/snowFall';
import { lazy, Suspense } from 'react';

const SnowFall = lazy(() => import('../SnowFall'));

export default function DelightRenderer() {
  const enabled = useDelightsEnabled();

  if (!enabled) return null;

  return (
    <>
      {isSnowFallSeasonActive() && (
        <Suspense fallback={null}>
          <SnowFall />
        </Suspense>
      )}
      {/* Add more delights here */}
    </>
  );
}
